import { render } from "./EmptyScreen.vue?vue&type=template&id=5709f952"
import script from "./EmptyScreen.vue?vue&type=script&lang=js"
export * from "./EmptyScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/EmptyScreen.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5709f952"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5709f952', __exports__)) {
    api.reload('5709f952', __exports__)
  }
  
  module.hot.accept("./EmptyScreen.vue?vue&type=template&id=5709f952", () => {
    api.rerender('5709f952', render)
  })

}


export default __exports__